export const config = {
  api: "https://i7d204.p.ssafy.io/api",
  // api: "http://localhost:8443/api",
};
